export const clientContent = {
  clientName: 'Commerzbank',
  siteLocation: 'London · Operational handover',
  siteCode: 'COMMERZBANK',
  systemName: 'Pulse',
  tagline: 'Building information',

  seo: {
    home: {
      title: 'Pulse | Commerzbank Building Information',
      description: 'Find trusted building information, quickly and in context. Assets, drawings, manuals and design records.',
    },
  },

  contact: {
    email: 'support@pulsebuilding.info',
    supportUrl: '#support',
  },
};

